module.exports = __webpack_public_path__ + "assets/facebook.7168a264.svg";